export const articleCategories = [
  "FIND_HOME", // e.g. searching, viewings, tenant checks, detecting scams
  "PLATFORMS", // rental platforms and sites
  "TEMPLATES", // e.g. check-in, check-out, inspection, lease forms
  "UTILITIES", // e.g. utility setup, billing tips, splitting costs
  "RENTAL_LAWS", // e.g. tenant rights, Dutch regulations, rent control
  "LANDLORD_TIPS", // e.g. screening tenants, setting rent, handling late payments
  "MAINTENANCE", // e.g. repairs, upkeep responsibilities, DIY fixes
  "MOVING", // e.g. relocation, packing, moving checklists
  "SECURITY", // e.g. home security systems, locks, fire safety
  "SUSTAIN", // e.g. energy labels, eco-friendly living, solar panels
  "FINANCE", // e.g. budgeting, rent insurance, handling rent increases
  "MARKET_COMPARE", // e.g. rental market trends, city vs. city, buy vs. rent
  "LIFESTYLE", // e.g. students, expats, pet-friendly rentals
  "COMMUNITY", // e.g. user stories, personal experiences, tips from renters
  "NEWS", // e.g. new laws, market trends, rental platforms
] as const;

export type ArticleCategory = (typeof articleCategories)[number];
